import gsap from 'gsap';

export default () => {
	document.querySelectorAll('.award-images-container').forEach((container, index) => {

		const hiddenImages = container.querySelectorAll('.hidden-images img, .hidden-images a');
		const images = Array.from(hiddenImages).map(img => ({
			src: img.tagName === 'A' ? img.querySelector('img').src : img.src,
			link: img.tagName === 'A' ? img.href : null,
			alt: img.querySelector('img') ? img.querySelector('img').alt : img.alt
		}));



		const coin = container.querySelector('.coin');
		const frontElement = document.createElement('div');
		const backElement = document.createElement('div');
		frontElement.classList.add('front');
		backElement.classList.add('back');
		coin.appendChild(frontElement);
		coin.appendChild(backElement);

		function createImageElement({ src, link, alt }) {
			const img = document.createElement('img');
			img.src = src;
			if (alt) img.alt = alt;
			if (link) {
				const a = document.createElement('a');
				a.href = link;
				a.appendChild(img);
				return a;
			}
			return img;
		}

		function updateElement(element, { src, link, alt }) {
			element.innerHTML = '';
			const newImg = createImageElement({ src, link, alt });
			element.appendChild(newImg);
		}

		let currentImageIndex = 0;

		if (images.length > 1) {
			console.log('award-images-container more than 1');
			function rotateCoin() {
				const nextImageIndex = (currentImageIndex + 1) % images.length;

				// Ensure the next image is set for the upcoming flip
				updateElement(backElement, images[nextImageIndex]);

				gsap.to(coin, {
					rotationY: '+=180',
					duration: 1,
					ease: 'power2.inOut',
					onComplete: () => {
						// Swap the images
						[frontElement.innerHTML, backElement.innerHTML] = [backElement.innerHTML, frontElement.innerHTML];

						// Update the current image index
						currentImageIndex = nextImageIndex;

						// Reset rotation for the next flip
						gsap.set(coin, { rotationY: 0 });

						// Pause before the next flip
						setTimeout(rotateCoin, 3000);
					}
				});
			}

			// Initialize the images
			updateElement(frontElement, images[currentImageIndex]);
			updateElement(backElement, images[(currentImageIndex + 1) % images.length]);

			// Start the rotation with a staggered delay
			setTimeout(rotateCoin, 3000 + (index+1) * 1000); // Staggered delay: 500ms offset per container
		} else {
			console.log('award-images-container 1');
			// Only one image, so no need to flip
			updateElement(frontElement, images[0]);
			updateElement(backElement, images[0]);
		}
	});
};
